// Social posts (post links upload): where a job's social posts and their
// coded comments are read by every member, and where a Manager adds posts
// from their links. It points at Add post links and the search and never
// clicks them: opening the form asks the server for the pipelines, and a
// walkthrough that said "Add post links" would be refused by the click guard
// ("post" is a commit word). Nothing is added.
// Opened on the page itself: /admin/<customer>/social-posts?walkthrough=social-posts.

import type { Walkthrough } from './types'

export const socialPosts: Walkthrough = {
  slug: 'social-posts',
  title: 'Social posts',
  summary:
    'Shows where a job’s social posts and their coded comments are read, and how a Manager adds posts from their links: paste or upload, choose a pipeline, preview, then confirm. Nothing is added.',
  added: '2026-10-25',
  steps: [
    {
      page: 'admin-social-posts',
      feature: 'autocoder/social-posts',
      say: 'This is Social posts, under Social in the Admin menu. Every member of the customer can open it. It lists the social media posts this job holds, with their platform, published date and metrics.',
    },
    {
      page: 'admin-social-posts',
      feature: 'autocoder/social-posts',
      control: 'Search name or URL',
      say: 'Search by a post’s name or link, or select a post to read its comments and how they were coded. Each YouTube post and comment shows the YouTube mark and name, linked to the original.',
    },
    {
      page: 'admin-social-posts',
      feature: 'autocoder/add-post-links',
      control: 'Add post links',
      say: 'A Manager selects Add post links, then pastes the links one per line, or chooses a .csv or .xlsx file. Everyone else sees this button greyed out, with the name of the person to ask.',
    },
    {
      page: 'admin-social-posts',
      feature: 'autocoder/add-post-links',
      control: 'Add post links',
      say: 'The form asks which pipeline should code the comments, and optionally a campaign, a dashboard label and a source. Preview then lists the posts, the links that cannot be added with the reason, and what fetching and coding will cost. Nothing is written until the Manager confirms.',
    },
    {
      page: 'admin-social-posts',
      feature: 'autocoder/youtube-attribution',
      say: 'Platinum refreshes YouTube comments every 25 days. A comment YouTube no longer returns keeps its codes but loses its text and author, and shows as deleted. An edited comment is stored with its new text and coded again.',
    },
  ],
}
